import _ from "lodash";
import constants from '../../../../globals/constants';

export const patterns = constants.patterns;
export class DefaultValidity {
    constructor(params) {
        this.setValidationConcerns(params);
    }

    setValidationConcerns(params) {
        this.required = _.get(params, "required", false);
        this.minlength = _.get(params, "minlength", false);
        this.maxlength = _.get(params, "maxlength", false);
        this.requireupper = _.get(params, "requireupper", false);
        this.requirelower = _.get(params, "requirelower", false);
        this.requirenumber = _.get(params, "requirenumber", false);
        this.min = _.get(params, "min", false);
        this.max = _.get(params, "max", false);
        this.mustNotBePoBox = _.get(params, "mustNotBePoBox", false);
        this.mustBeAddress = _.get(params, "mustBeAddress", false);
        this.noTollFreeNumber = _.get(params, "noTollFreeNumber", false);
        this.checkValidPhone = _.get(params, "checkValidPhone", false);
    }


    checkValidity(value) {
        if (this.required) {
            const result = this.requiredCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.minlength) {
            const result = this.minlengthCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.maxlength) {
            const result = this.maxlengthCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.requirelower) {
            const result = this.requirelowerCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.requireupper) {
            const result = this.requireupperCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.requirenumber) {
            const result = this.requirenumberCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.min) {
            const result = this.minCheck(value);

            if (!result.valid) {
                return result;
            }
        }

        if (this.max) {
            const result = this.maxCheck(value);
            if (!result.valid) {
                return result;
            }
        }

        if (this.mustNotBePoBox) {
            const result = this.poboxCheck(value);
            if (!result.valid) {
                return result;
            }
        }
    
        if (this.mustBeAddress) {
            const result = this.addressCheck(value);
            if (!result.valid) {
                return result;
            }
        }
        
        if (this.checkValidPhone) {
            const result = this.validPhoneCheck(value);
            if (!result.valid) {
                return result;
            }
        }

        if (this.noTollFreeNumber) {
            const result = this.tollFreeCheck(value);
            if (!result.valid) {
                return result;
            }
        }

        return {
            isValid: true
        };
    }

    minlengthCheck(value) {
        return {
            inputAttr: "minlength",
            valid: value.length >= this.minlength
        };
    }

    maxlengthCheck(value) {
        return {
            inputAttr: "maxlength",
            valid: value.length <= this.maxlength
        };
    }

    requirelowerCheck(value) {
        return {
            inputAttr: "requirelower",
            valid: /[a-z]/.test(value)
        };
    }

    requireupperCheck(value) {
        return {
            inputAttr: "requireupper",
            valid: /[A-Z]/.test(value)
        };
    }

    requirenumberCheck(value) {
        return {
            inputAttr: "requirenumber",
            valid: /\d/.test(value)
        };
    }

    requiredCheck(value) {
        return {
            inputAttr: "required",
            valid: !(
                _.isNil(value) ||
        value === "" ||
        (Array.isArray(value) && !value.length)
            )
        };
    }

    minCheck(value) {
        return {
            inputAttr: "min",
            valid: value >= this.min
        };
    }

    maxCheck(value) {
        return {
            inputAttr: "max",
            valid: value <= this.max
        };
    }

    addressCheck(value) {
        const pattern = patterns.address();
        return {
            inputAttr: "mustBeAddress",
            valid: pattern.test(value)
        };
    }

    poboxCheck(value) {
        const pattern = patterns.poBox;
        return {
            inputAttr: "mustNotBePoBox",
            valid: !pattern.test(value)
        };
    }

    tollFreeCheck(value) {
        const pattern = patterns.tollFreeNumbers();
        return {
            inputAttr: "tollFreeCheck",
            valid: pattern ? !pattern.test(value) : true
        }
    }

    validPhoneCheck(value) {
        const pattern = patterns.validPhone();
        return {
            inputAttr: "validPhoneCheck",
            valid: pattern.test(value)
        }
    }

    static get requiredMessage() {
        return "This field is required";
    }

    static get minlengthMessage() {
        return "Must contain at least ";
    }

    static get maxlengthMessage() {
        return "Cannot have more than ";
    }

    static get requirelowerMessage() {
        return "Please include at least 1 lower case letter.";
    }

    static get requireupperMessage() {
        return "Please include at least 1 upper case letter.";
    }

    static get requirenumberMessage() {
        return "Please include at least 1 number.";
    }

    static get minMessage() {
        return "The value is too small.";
    }

    static get maxMessage() {
        return "The value is too large.";
    }

    static get poboxMessage() {
        return "Please use a physical address. P.O. boxes are not allowed.";
    }

    static get tollFreeNumberMessage() {
        return "Please provide another number. Toll free numbers are not allowed."
    }

    static get invalidPhoneMessage() {
        return "Please enter a valid 10 digit phone number"
    }
}
